import { orgIDMap } from "./orgIdMap";

export const getOrgConfig = (orgId: string) => {
  if (!orgId || !orgIDMap[orgId]) {
    alert(`Invalid or missing orgId in the URL: ${orgId}`);
    return null;
  }
  const finalId = orgIDMap[orgId];
  console.log({ finalId });
  const userPoolIdKey = `REACT_APP_${finalId}_USER_POOL_ID`;
  const clientIdKey = `REACT_APP_${finalId}_CLIENT_ID`;

  return {
    userPoolId: process.env[userPoolIdKey] || "",
    clientId: process.env[clientIdKey] || "",
  };
};
